module Main exposing (..)

import Browser
import Init exposing (init)
import Messages exposing (Message(..))
import Models exposing (Model)
import Ports exposing (messageReceiver)
import Update exposing (update)
import View exposing (view)



---- PROGRAM ----


main : Program () Model Message
main =
    Browser.application
        { init = init
        , view = view
        , update = update
        , subscriptions = subscriptions
        , onUrlChange = UrlChanged
        , onUrlRequest = LinkClicked
        }


subscriptions : Model -> Sub Message
subscriptions _ =
    messageReceiver UpdateViewport
